import PropTypes from 'prop-types';

import { Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const PortletLabel = props => {
  const { className, icon, title, subtitle, sx, ...rest } = props;
  const theme = useTheme();
  const rootStyling = { display: 'flex', alignItems: 'baseline' };

  return (
    <Box {...rest} sx={[rootStyling, ...(Array.isArray(sx) ? sx : [sx])]} className={className}>
      {icon && (
        <span
          style={{
            fontSize: '1.3rem',
            marginRight: theme.spacing(1),
            color: theme.palette.text.secondary,
            alignItems: 'center',
            display: 'flex',
          }}
        >
          {icon}
        </span>
      )}
      {title && (
        <Typography sx={{ fontWeight: 500 }} variant="h5">
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography
          sx={{
            fontWeight: 400,
            marginLeft: theme.spacing(1),
            color: theme.palette.text.secondary,
          }}
          variant="subtitle2"
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

PortletLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.node,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

PortletLabel.defaultProps = {
  children: undefined,
  className: 'portlet-label',
  icon: undefined,
  subtitle: '',
  title: '',
  sx: undefined,
};

export default PortletLabel;
